import MiscUtils from './MiscUtils'

import * as firebase from 'firebase'

const LoginUtils = {

  loginWithToken(token) {
    return firebase.auth()
      .signInWithCustomToken(token)
  },

  sendSmsCode(phoneNumber) {
    const params = {
      phoneNumber: phoneNumber
    }
    return MiscUtils.sendSMSCode(params)
  },

  loginWithCustomToken(phoneNumber) {
    const params = {
      phoneNumber: phoneNumber
    }
    return MiscUtils.fetchEndPoint('tokenLogin', params)
      .then(response => firebase.auth().signInWithCustomToken(response.token))
  }

}

export default LoginUtils



// WEBPACK FOOTER //
// ./src/infra/LoginUtils.js